import { useState, useEffect, useCallback } from 'react'
import { projectsApi } from '../api/client'

export function useProjects(options = {}) {
  const { departmentId, status, myProjects = true } = options
  const [projects, setProjects] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchProjects = useCallback(async () => {
    try {
      setLoading(true)
      const params = {}
      if (departmentId) params.department_id = departmentId
      if (status) params.status = status
      if (myProjects) params.my_projects = true
      const response = await projectsApi.list(params)
      // Ensure we always have an array, even if API returns unexpected data
      setProjects(Array.isArray(response.data) ? response.data : [])
      setError(null)
    } catch (err) {
      setError(err.message || 'Failed to fetch projects')
    } finally {
      setLoading(false)
    }
  }, [departmentId, status, myProjects])

  useEffect(() => {
    fetchProjects()
  }, [fetchProjects])

  const createProject = async (data) => {
    const response = await projectsApi.create(data)
    setProjects(prev => [response.data, ...prev])
    return response.data
  }

  const updateProject = async (projectId, data) => {
    const response = await projectsApi.update(projectId, data)
    setProjects(prev => prev.map(p => p.id === projectId ? response.data : p))
    return response.data
  }

  const deleteProject = async (projectId) => {
    await projectsApi.delete(projectId)
    setProjects(prev => prev.filter(p => p.id !== projectId))
  }

  return {
    projects,
    loading,
    error,
    refresh: fetchProjects,
    createProject,
    updateProject,
    deleteProject,
  }
}
